import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { appointmentHasParallelAppointments, ScheduleCalendarElement } from '@libs/store';
import { PushTagOnClickDirective, TagEvent } from '@libs/shared-services';
import { TranslateModule } from '@ngx-translate/core';
import { ScheduleCalendarItemComponent } from '../schedule-calendar-item';
import { ScheduleTimeToGridRowPipe } from '../../schedule-time-to-grid-row';
@Component({
  selector: 'lib-schedule-calendar-my-day',
  templateUrl: './schedule-calendar-my-day.component.html',
  styleUrl: './schedule-calendar-my-day.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScheduleCalendarItemComponent, ScheduleTimeToGridRowPipe, NgClass, PushTagOnClickDirective, TranslateModule],
})
export class ScheduleCalendarMyDayComponent {
  @Input() public myDay: ScheduleCalendarElement[] = [];
  @Input() public selectedAppointmentId?: string;
  @Input() public isShowcase = false;
  @Input() public completedStatusId?: string;

  @Output() public calendarItemClick = new EventEmitter<string>();

  protected readonly TagEvent = TagEvent;

  protected onCalendarItemClick(appointmentId: string): void {
    this.calendarItemClick.emit(appointmentId);
  }

  protected elementHasParallelAppointments(appointment: ScheduleCalendarElement): boolean {
    return appointmentHasParallelAppointments(appointment, this.myDay);
  }
}
